var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Right"},[_c('div',{staticClass:"right-nav"},[_c('ModuleTitle',{attrs:{"title":"未完成订单"}}),_c('Power')],1),_c('div',{staticClass:"right-tray"},[_c('ModuleTitle',{attrs:{"title":"已完成订单"}}),_c('Table')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }